<template>
  <BittsContainer class="enterprise-horizontal-card">
    <div class="flex flex-col items-start gap-8">
      <div class="flex items-center gap-8">
        <h2>Enterprise</h2>
        <BittsTag size="x-small" color="new">
          <template #pre>
            <FontAwesomeIcon class="mr-4 h-12 w-12" :icon="['fak', 'star']" />
          </template>
          <span>New</span>
        </BittsTag>
      </div>
      <section>
        <p class="font-bold"
          >Need greater access controls, advanced security, and custom support?
          Talk to our sales teams today about our Enterprise plan</p
        >
        <p
          >For large organizations navigating complex partnerships, global
          teams, and large-scale collaboration</p
        >
      </section>
    </div>
    <BittsButton
      text="Talk to Sales"
      size="medium"
      type="upsell"
      :left-icon="['fak', 'upgrade']"
      class="ml-auto"
      @click="
        handleBillingInteraction({
          talkToSalesReason: 'Upgrade to Enterprise',
          event_site:
            EVENT_SITES.EXPLORE_PLANS_SUPERNODE_BUTTON /* TODO, update these */,
        })
      "
    />
  </BittsContainer>
</template>

<script setup lang="ts">
import { BittsButton, BittsContainer, BittsTag } from '@crossbeam/bitts';
import { EVENT_SITES } from '@crossbeam/itly';

import useBilling from '@/composables/useBilling';

const { handleBillingInteraction } = useBilling();
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.enterprise-horizontal-card {
  @apply p-24 flex items-center justify-between gap-8;
}
h2 {
  @apply font-bold text-xl;
  background: linear-gradient(
    90deg,
    theme(colors.blue-700) 0.13%,
    theme(colors.primary-accent) 24.57%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
p {
  @apply text-neutral-text-weak;
}
</style>
